import React from 'react';
import { Typography, CircularProgress, Tooltip } from '@mui/material';
import { Box } from '@mui/material';

import { colorText } from "./theme.js";
import { getTokenNameByResourceId, isMobile, RESOURCE } from "./utils";
import { formatMoney } from "../utils";

import AnimatedNumber from "../User/AnimatedNumber";

export const RenderBalances = ({ loadingBalances, balances, kbSubdomain }) => {
    const typographyVariant = isMobile ? 'h8' : 'h6';

    const styleLoadingBox = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        width: '100%',
        marginLeft: isMobile ? '-20px' : '25%'
    };

    const styleBox = {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        width: '100%',
        marginLeft: isMobile ? (kbSubdomain ? '35px' : '20px') : (kbSubdomain ? '20px' : '60px'),
        marginRight: '20px'
    };

    const balanceStyle = {
        fontSize: 14,
        textAlign: 'left',
        my: 0,
        mx: isMobile ? 0 : 2
    };

    const component = loadingBalances ? (
        <Box sx={styleLoadingBox}>
            <CircularProgress />
        </Box>
    ) : (
        <Box sx={styleBox}>
            {(balances?.length ? balances : [{ balance: null, resourceId: RESOURCE.tokens }])
                .filter(o => [RESOURCE.tokens].includes(o.resourceId))
                .sort((a, b) => b.resourceId.localeCompare(a.resourceId))
                .map((balance, index) => (
                    <Typography variant={typographyVariant} component="p" sx={balanceStyle}>
                        {!isMobile && balance.balance !== null && <span style={{ color: colorText }}>
                                Credits: </span>}
                        <AnimatedNumber
                            hide={balance.balance === null}
                            number={balance.balance}
                            formatter={(amount) => formatMoney(amount, '', colorText)}
                        />
                    </Typography>
                ))}
        </Box>
    );

    return (
        <Box sx={{ flexGrow: 1, display: 'flex', justifyContent: 'right', alignItems: 'center', height: '100%' }}>
            <Box sx={{
                width: '100%',
                maxWidth: 200,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'flex-start',
            }}>
                {component}
            </Box>
        </Box>
    );
};